{
	"_embedded": {
		"item": [
			{
				"description": "Step description 2 Lorem Ipsum",
				"language": "en-US",
				"_links": {
					"self": {
						"href": "https://dev.backend.ka.philips.com/api/RecipeStep/Translation/0432uyh423i42h44"
					}
				}
			}
		]
	},
	"_links": {
		"first": {
			"href": "https://dev.backend.ka.philips.com/api/Recipe/Step/435d6rft7gy8hu/Translation?page=0&size=10"
		},
		"item": [
			{
				"href": "https://dev.backend.ka.philips.com/api/RecipeStep/Translation/0432uyh423i42h44"
			}
		],
		"last": {
			"href": "https://dev.backend.ka.philips.com/api/Recipe/Step/435d6rft7gy8hu/Translation?page=10&size=10"
		},
		"next": {
			"href": "https://dev.backend.ka.philips.com/api/Recipe/Step/435d6rft7gy8hu/Translation?page=2&size=10"
		},
		"prev": {
			"href": "https://dev.backend.ka.philips.com/api/Recipe/Step/435d6rft7gy8hu/Translation?page=0&size=10"
		},
		"self": {
			"href": "https://dev.backend.ka.philips.com/api/Recipe/Step/435d6rft7gy8hu/Translation?page=1&size=10"
		}
	}
}
